document.addEventListener('DOMContentLoaded', function() {
  console.log("Simple product image navigation loading");
  
  // Remove any existing navigation components
  const existingArrows = document.querySelectorAll('.product-image-arrow');
  existingArrows.forEach(arrow => arrow.remove());
  
  // Find all product cards
  const productCards = document.querySelectorAll('.grid__item');
  
  productCards.forEach(card => {
    // Find the media container in this card
    const mediaContainer = card.querySelector('.card__media');
    if (!mediaContainer) return;
    
    // Find the image
    const mediaWrapper = mediaContainer.querySelector('.media');
    if (!mediaWrapper) return;
// Get all images in the media wrapper
const images = mediaWrapper.querySelectorAll('img');
if (!images.length) return;

// Always use the first (primary) image - this is what users see on mobile
// The second image (if present) is only for hover effect on desktop
const primaryImage = images[0];
const secondaryImage = images.length > 1 ? images[1] : null;
    
    //const primaryImage = mediaWrapper.querySelector('img');
    // if (!primaryImage) return;
    
    // Get product URL and handle
    const productLink = card.querySelector('a[href*="/products/"]');
    if (!productLink) return;
    
    const productURL = productLink.getAttribute('href');
    const productHandle = productURL.split('/products/')[1].split('?')[0];
    
    // Create navigation arrows
    const leftArrow = document.createElement('button');
    leftArrow.className = 'product-image-arrow product-image-arrow--left';
    leftArrow.setAttribute('aria-label', 'Previous image');
    leftArrow.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';
    
    const rightArrow = document.createElement('button');
    rightArrow.className = 'product-image-arrow product-image-arrow--right';
    rightArrow.setAttribute('aria-label', 'Next image');
    rightArrow.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';
    
    // Create loading indicator
    const loadingIndicator = document.createElement('div');
    loadingIndicator.className = 'product-image-loading';
    loadingIndicator.innerHTML = '<div class="spinner"></div>';
    
    // Add navigation elements to the media container
    mediaContainer.appendChild(leftArrow);
    mediaContainer.appendChild(rightArrow);
    mediaContainer.appendChild(loadingIndicator);
    
    // Initialize product images array and state variables
    let productImages = [];
    let currentImageIndex = 0;
    let imageLoading = false;
    
    // Function to update the displayed image
    const updateImage = () => {
      if (imageLoading || productImages.length <= 1) return;
      
      // Show loading indicator
      loadingIndicator.classList.add('active');
      imageLoading = true;
      
      // Create a new image element to preload
      const newImg = new Image();
      
      // Set up onload handler
      newImg.onload = function() {
        // Replace image source
        const baseSrc = productImages[currentImageIndex];
        primaryImage.setAttribute('src', baseSrc);

        // Remove any srcset to ensure our image is shown
        if (primaryImage.hasAttribute('srcset')) {
          primaryImage.removeAttribute('srcset');
        }

        // Also update secondary/hover image if present (for consistent desktop experience)
        if (secondaryImage) {
          secondaryImage.setAttribute('src', baseSrc);
          if (secondaryImage.hasAttribute('srcset')) {
            secondaryImage.removeAttribute('srcset');
          }
        }
        
        // Hide loading indicator
        loadingIndicator.classList.remove('active');
        imageLoading = false;
        
        // Update arrow states
        leftArrow.classList.toggle('disabled', currentImageIndex === 0);
        rightArrow.classList.toggle('disabled', currentImageIndex === productImages.length - 1);
      };
      
      // Add error handler
      newImg.onerror = function() {
        console.error(`Failed to load image: ${productImages[currentImageIndex]}`);
        loadingIndicator.classList.remove('active');
        imageLoading = false;
      };
      
      // Start loading the image
      newImg.src = productImages[currentImageIndex];
    };
    
    // Fetch product images
    fetch(`/products/${productHandle}.json`)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        return response.json();
      })
      .then(data => {
        if (!data.product || !data.product.images) {
          throw new Error('No product images found');
        }
        
        const images = data.product.images;
        if (images && images.length > 0) {
          // Store full-resolution images
          productImages = images.map(img => {
            let fullUrl = img.src;
            // Remove any size constraints from URL
            fullUrl = fullUrl.replace(/(_\d+x\d+)?(\.\w{3,4})$/, '$2');
            return fullUrl;
          });
          
          console.log(`Found ${productImages.length} images for ${productHandle}`);
          
          // Hide arrows if only one image
          if (productImages.length <= 1) {
            leftArrow.style.display = 'none';
            rightArrow.style.display = 'none';
          } else {
            // Initialize arrow states
            currentImageIndex = 0;
            leftArrow.classList.add('disabled');
            rightArrow.classList.toggle('disabled', productImages.length <= 1);
          }
        } else {
          // Hide arrows if no images
          leftArrow.style.display = 'none';
          rightArrow.style.display = 'none';
        }
      })
      .catch(error => {
        console.error(`Error fetching product data for ${productHandle}:`, error);
        // Hide arrows on error
        leftArrow.style.display = 'none';
        rightArrow.style.display = 'none';
      });
    
    // Add event listeners for arrows
    leftArrow.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      if (currentImageIndex > 0 && !imageLoading) {
        currentImageIndex--;
        updateImage();
      }
    });
    
    rightArrow.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      if (currentImageIndex < productImages.length - 1 && !imageLoading) {
        currentImageIndex++;
        updateImage();
      }
    });
  });
  
  // Add minimal CSS for arrows and loading indicator
  const style = document.createElement('style');
  style.textContent = `
    .card__media {
      position: relative !important;
    }
    
    .product-image-arrow {
      position: absolute !important;
      top: 50% !important;
      transform: translateY(-50%) !important;
      z-index: 1000 !important; /* Very high z-index to ensure visibility */
      width: 36px !important;
      height: 36px !important;
      border-radius: 50% !important;
      background-color: rgba(255, 255, 255, 0.7) !important;
      border: 1px solid rgba(0, 0, 0, 0.05) !important;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      cursor: pointer !important;
      transition: all 0.2s ease !important;
      opacity: 0.6 !important;
      padding: 0 !important;
      pointer-events: auto !important;
    }
    
    .product-image-arrow:hover {
      background-color: rgba(255, 255, 255, 0.9) !important;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15) !important;
      opacity: 0.9 !important;
      transform: translateY(-50%) scale(1.05) !important;
    }
    
    .product-image-arrow svg {
      width: 20px !important;
      height: 20px !important;
      stroke: #555 !important;
      stroke-width: 1.5px !important;
    }
    
    .product-image-arrow--left {
      left: 5px !important;
    }
    
    .product-image-arrow--right {
      right: 5px !important;
    }
    
    .product-image-arrow.disabled {
      opacity: 0.3 !important;
      cursor: not-allowed !important;
      pointer-events: none !important;
    }
    
    .product-image-loading {
      position: absolute !important;
      top: 0 !important;
      left: 0 !important;
      width: 100% !important;
      height: 100% !important;
      background-color: rgba(255, 255, 255, 0.5) !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      z-index: 999 !important; /* Lower than arrows but higher than content */
      opacity: 0 !important;
      pointer-events: none !important;
      transition: opacity 0.2s ease !important;
    }
    
    .product-image-loading.active {
      opacity: 1 !important;
    }
    
    .spinner {
      width: 30px !important;
      height: 30px !important;
      border-radius: 50% !important;
      border: 2px solid rgba(0, 0, 0, 0.1) !important;
      border-top-color: #555 !important;
      animation: spinner 0.8s infinite linear !important;
    }

    .card--media .card__inner .card__content {
    position:absolute!important;
    }

    .card--card .card__heading a:after {
    display:none;
    }
    
    @keyframes spinner {
      to {
        transform: rotate(360deg);
      }
    }
  `;
  document.head.appendChild(style);
  
  console.log("Simple product image navigation loaded");
});